import { Navigate, useParams } from 'react-router-dom';

/** Legacy route — redirects to Release tab with optional config filter. */
export default function CourseKeyMindtapEnrollmentsRedirect() {
  const { configId } = useParams<{ configId: string }>();
  const search = configId
    ? `?tab=release&configId=${encodeURIComponent(configId)}`
    : '?tab=release';
  return <Navigate to={`/course-keys${search}`} replace />;
}
